import axios from 'axios';
import axiosInstance from "./axiosInstance";
import { suppressLoaderOnce } from './loadingBridge';

export interface ApiResponse {
    status: string;
    statusText: string;
    headers: string;
    config: {
        data: number;
    };
}
// Single package structure
export interface CoinPackage {
    coins: number;
    price: number;
}

// All available packages keyed by size
export interface CoinPackages {
    small: CoinPackage;
    medium: CoinPackage;
    large: CoinPackage;
}

// Main data structure
export interface CoinPackageResponseData {
    status?: string;
    packages?: CoinPackages;
}

// Full Axios response (optional, for more completeness)
export interface CoinPackageApiResponse {
    data: CoinPackageResponseData;
    status: number;
    statusText: string;
    headers: Record<string, any>;
    config: Record<string, any>;
    request?: any;
}

interface StripeSessionIdResponse {
    status: string;
    message: string;
    coins: number;
}

interface StripeCoinCheckoutResponse {
    status: string;
    checkout_url?: string;
    message?: string;
    details?: string;
}

export const getUserCoin = async () => {
    try {
        suppressLoaderOnce();
        const response = await axiosInstance.get<ApiResponse>("/buy-coins/coins");
        return response.data;
    } catch (error:any) {
        console.error("Error fetching coin package details ", error);
        return error?.response?.data || null;
    }
}

export const getCoinPackageDetails = async () => {
    try {
        const response = await axiosInstance.get<CoinPackageApiResponse>("/buy-coins");
        return response.data;
    } catch (error:any) {
        console.error("Error fetching coin package details ", error);
        return error?.response?.data || null;
    }
}

export const buyCoinPackage = async (pkg: string) => {
    try {
        const response = await axiosInstance.get<StripeCoinCheckoutResponse>(`/buy-coins/checkout/${pkg}`);
        return response.data;
    } catch (error: any) {
        console.error("Error buying coin package ", error);
        return error?.response?.data || null;
    }
}

export const sendStripeSessionId = async (session_id: string | null, pkg: string | null) => {
    try {
        const response = await axiosInstance.get<StripeSessionIdResponse>(`/buy-coins/success/${pkg}`, {
            params: { session_id },
        });
        return response.data;
    } catch (error: any) {
        console.error("Error buying coin package", error);
        return error.response?.data || null;
    }
};